import { Button } from "@/components/ui/Button";
import type { ScrapingControlsProps } from "@shared/types/scraping";
import { Loader2, Play } from "lucide-react";
import { useTranslation } from "react-i18next";
import * as styles from "./ScrapingControls.styles";

const ScrapingControls = ({ scraping, onScrape }: ScrapingControlsProps) => {
  const { t } = useTranslation("scraping");
  return (
    <div className={styles.container}>
      <div className={styles.controlsInner}>
        <Button onClick={onScrape} disabled={scraping} variant="gradient" size="lg" className={styles.scrapeBtn}>
          {scraping ? (
            <>
              <Loader2 className={`${styles.icon} animate-spin`} />
              {t("scrapingInProgress")}
            </>
          ) : (
            <>
              <Play className={styles.icon} />
              {t("start")}
            </>
          )}
        </Button>
      </div>
    </div>
  );
};

export { ScrapingControls };
